import { Component, OnInit, Pipe, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { HomeService } from '../_services/home.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalConfig, } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common'
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient, HttpEventType } from '@angular/common/http';
import moment from 'moment';
import { Title } from '@angular/platform-browser';
import { AuthenticationService } from '../_services';
import { GoogleAnalyticsService } from '../_services/google-analytics.service';
import { environment } from '../../environments/environment';
export let checkCaseModalInHelpCenter = false;

@Component({
  selector: 'app-help-center',
  templateUrl: './help-center.component.html',
  styleUrls: ['./help-center.component.scss'],
  providers: [DatePipe]
})
// @Pipe({
//   name: "sort"
// })
export class HelpCenterComponent implements OnInit {
  myHelpCenterConfigurationOptionLabel: Array<any>;
  ticketListLabel: any;
  listSizeNotes: any;
  helpCenterCases: any;
  caseStatus: Array<any>
  header: any;
  linkText: Array<any>;
  myHelpCaseLabel: any;
  statusNew: boolean = false;
  caseAlertMessage: string;
  alert: boolean = false;
  delayed: boolean = false;
  helpCenterLabel: boolean = false;
  searchText = false
  imageSource: "./assets/images/survey.png";
  chatform: FormGroup
  fieldType: string;
  fieldTypes: Array<any>
  submitted: boolean = false;
  fields: [];
  showModal: boolean = true
  institutionId: string
  error: any;
  files: Array<any> = []
  fileToUpload: any;
  file: { file_name: any; content_type: any; file_path: any; };
  i18n: any;
  storage: any;
  uploadedFiles: any;
  uploadedFile: [];
  progress: number
  file_size: number = 0;
  upload: any;
  status: boolean = false;
  file_length: number = 0;
  regexFile: boolean;
  regexFormat: string;
  current_upload_size: number = 0;
  UploadFailedMessage: boolean;
  SelectedFile: number;
  sizeExceededMessage: boolean;
  fileProgress: boolean = true;
  uploadedFileLength: any;
  UploadingFile: boolean;
  UploadedFileName: any;
  duplicateFiles: boolean = true;
  userFields: Array<any>;
  form: { comment: any; attachment: any[]; };
  comment: any;
  field: { file_name: any; content_type: any; file_path: any; };
  ticket: any;
  history: string;
  attachment: any;
  chatTranscriptAttachments: any;
  action: any;
  instId: any;
  ticketLabel: any;
  defaultSurvey: boolean;
  surveyFields: any;
  disAbleSurvey: boolean;
  defaultSurveyList: any;
  isDefaultSurveyPresent: boolean;
  noDefaultCustom: boolean;
  isDefaultCustomPresent: boolean;
  defaultCustomSurvey: any;
  searchdata: any[];
  selectedValue: any;
  keyword = 'name';
  data = [];
  innerWidth: number;
  checkCaseModalInHelpCenter: boolean = false;
  searchBanner: any;
  searchTextboxNote: any;
  searchTextboxHover: any;
  searchButtonHover: any;
  searchKey: any;
  isNotAuthorised: boolean;
  isSmartViewChat: any;
  ghTitle: any;
  showOnSelfHelp:  boolean = false;
  a: HTMLAnchorElement;
  disableLiveChatSHP: any;
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
    console.log("Inner width = ", this.innerWidth);
  }
  constructor(private router: Router, private homeService: HomeService, private http: HttpClient, private formBuilder: FormBuilder, private modalService: NgbModal, private spinner: NgxSpinnerService, private datepipe: DatePipe, private authService: AuthenticationService,private gaService : GoogleAnalyticsService) { }

  ngOnInit() {
    this.getTrackerConfig();
    this.homeService.getShpLogin().subscribe(res=>{
      this.isSmartViewChat=res.return_body.is_smart_view_chat;
      this.disableLiveChatSHP = res.return_body.disable_live_chat_SHP
      })
    let autoChatOpen = this.authService.getValueInConfigFromLocalStorage('autoOpenChatWindow');
    if (autoChatOpen !== null && autoChatOpen === "yes") {
      this.homeService.openChat.next(true);
    }
    console.log('url', this.router.url)
    if (sessionStorage.getItem('i18n')) {
      this.i18n = JSON.parse(sessionStorage.getItem('i18n'));
    }
    this.chatform = this.formBuilder.group(
      {
        comment: ['', [Validators.required]],
      });
    let currentUser = JSON.parse(this.authService.getCurrentUser());
    if (currentUser !== null && currentUser.user !== null) {
      this.homeService.getHelpCenterConfiguration().subscribe(res => {
        this.gaService.updatePageName();
        this.myHelpCenterConfigurationOptionLabel = res.return_body.myHelpCenterOptionalLable
        this.helpCenterLabel = this.myHelpCenterConfigurationOptionLabel[0].labelEnabler
        this.ticketListLabel = res.return_body.ticketListLabel
        this.listSizeNotes = res.return_body.listSizeNotes
        this.homeService.getCaseConfiguration().subscribe(res => {
          this.helpCenterCases = res.return_body
          this.isNotAuthorised = false
        },
          error => {
            if (error.status == 401) {
              this.isNotAuthorised = true
            }
          })
      })
      this.getHeaderConfig();
      this.caseMessage();
    } else {
      console.log("INSIDE ELSE BLOCK LOOPING");
      this.homeService.navigateToLogin(this.router.url);
      // this.router.navigate([this.router.url.split("/")[1], 'login']);
    }
    let institutionId = this.homeService.institutionId
    this.homeService.getDefaultSurveyFields(institutionId).subscribe(res => {
      this.defaultSurveyList = res.return_body
      if (this.defaultSurveyList != null) {
        this.isDefaultSurveyPresent = true;
      }
    })
    this.getCustomFields();
    if(localStorage.getItem('showCreateCase') == 'yes') {
      this.createCaseLink();
   }
  }

  getTrackerConfig() {
    this.homeService.trackerConfig().subscribe(res => {
      this.showOnSelfHelp = res.return_body.showOnSelfHelp;
    })
  }

  kbSearchConfig() {
    this.homeService.getKbSearchConfiguration().subscribe(res => {
      this.searchBanner = res.return_body.searchBanner;
      this.searchTextboxNote = res.return_body.searchTextboxNote;
      this.searchTextboxHover = res.return_body.searchTextboxHoverNote;
      this.searchButtonHover = res.return_body.searchButtonHoverNote;
    });
  }

  getCustomFields() {
    let institutionId = this.homeService.institutionId
    this.homeService.getCustomSurveyFields(institutionId).subscribe(res => {
      const customSurveyList = res.return_body
      for (let customSurvey of customSurveyList) {
        if (customSurvey.surveyCommonConfig.defaultCustomSurvey) {
          this.defaultCustomSurvey = customSurvey.surveyCommonConfig.defaultCustomSurvey
        }
      }
    });
  }
  getHeaderConfig() {
    this.homeService.getHeaderConfig().subscribe(res => {
      this.header = res.return_body;
      this.linkText = this.header.headerHyperLink.linkText
    });
  }
  sort(prop: string) {
    return this.helpCenterCases.sort((a, b) => a[prop] < b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);
  }
  createCaseLink() {
    // this.router.navigate([this.router.url.split("/")[1], 'createcase']);
    this.checkCaseModalInHelpCenter = true;
  }
  selectEvent(item) {
    this.selectedValue = item.name;
    this.search(this.selectedValue);
  }

  onChangeSearch(val: string) {
    this.selectedValue = val;
    this.data = [];
    if (val != '') {
      this.homeService.getSearchData(val).subscribe(res => {
        this.data = [];
        res.return_body.map((response, index) => {
          this.data.push({ id: index, name: response });
        })
      });
    }
  }

  onFocused(e) {
    this.data = [];
  }

  search(selectedValue) {
    this.router.navigate(['/' + this.router.url.split('/')[1] + '/searchresults'], { queryParams: { selectedValue: selectedValue, currentPage: 0 } });
  }
  onKeyEnterSearch(event: any, searchkeyWrd: any) {
    this.search(searchkeyWrd);
  }

  searchCleared() {
    this.selectedValue = '';
  }
  navigationLink(i) {
    if (i == 0) {
      this.spinner.show();
      setTimeout(() => {
        this.spinner.hide();
      }, 2000);
      this.router.navigate([this.router.url.split("/")[1], 'helpcenter']);
    }
    else {
      this.router.navigate([this.router.url.split("/")[1], '#']);
    }
  }


  handleNavigation() {
    this.router.navigate([this.router.url.split("/")[1], 'home']);
  }
  handleSurveyNavigation(ticket_number) {
    this.authService.setTicket(ticket_number);//localStorage.setItem('ticket',ticket_number);
    this.router.navigate([this.router.url.split("/")[1], 'survey'], { queryParams: { ticket: ticket_number } });

  }

  handleTrackerNavigation() {
    if(this.showOnSelfHelp == true){
      this.router.navigate([this.router.url.split("/")[1], 'tracker']);
    }
  }

  validToken() {
    this.homeService.getTokenValidity().subscribe(data => {
    },
      error => {
        console.log(error);
      });
  }

  caseMessage() {
    this.caseAlertMessage = sessionStorage.getItem('alertMessage')
    if (this.caseAlertMessage) {
      this.alert = true
    }
    setInterval(() => {
      this.delayed = true
      this.alert = false
      sessionStorage.removeItem('alertMessage')
    }, 5000);
  }

  viewCase(ticketNumber) {
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 1000);
    this.homeService.getCase(ticketNumber).subscribe(res => {
      this.ticket = res.return_body;
      this.instId = this.homeService.institutionId
      this.caseId = res.return_body.ticket_number.split('-')[1];
      this.history = this.concatHistories(res.return_body.history.reverse())
      this.action = res.return_body.actions;
      this.attachment = res.return_body.attachment
      this.chatTranscriptAttachments = res.return_body.chatTranscriptAttachment
      this.attachment.forEach(attachment => {
        attachment.titleName = attachment.name;
        if (attachment.name.length > 51) {
          var nameStart = attachment.name.substring(0, 24);
          var nameEnd = attachment.name.substring(attachment.name.length - 24);
          attachment.name = nameStart + "..." + nameEnd;
        }
      });
    });
  }

  downloadFile(file_id, file_name ) {
    this.homeService.getFiles(file_id).subscribe(res  => {
      this.a = document.createElement("a");
          this.a.href = URL.createObjectURL(res);
          this.a.download = file_name;
          this.a.click();
    })
  }

  concatHistories(histories) {

    if (sessionStorage.getItem('i18n')) {
      this.i18n = JSON.parse(sessionStorage.getItem('i18n'));
    }
    this.chatform = this.formBuilder.group(
      {
        comment: ['', [Validators.required]],
      })
    if (!histories) {
      return;
    }
    var resultHitories = '';
    var newHistory = "";
    for (var i = 0; i < histories.length; i++) {
      if (newHistory != '') {
        newHistory = newHistory + "<br/>";
      }
      var createdDate = "";
      if (histories[i].action_date && histories[i].action_date != null && histories[i].action_date != '') {
        createdDate = moment(histories[i].action_date).format('yyy-MM-DD hh:mm a')
      }
      newHistory = newHistory + "<p><strong>" + createdDate + '&nbsp;&nbsp;&nbsp;&nbsp;' + histories[i].action + "</strong> </p>";
      newHistory = newHistory + "<p>" + histories[i].comment + "</p>";
      if (histories[i].attachment && histories[i].attachment.length > 0) {
        for (var j = 0; j < histories[i].attachment.length; j++) {
          newHistory = newHistory + "<p><a href='/api/v1/" + this.instId + "/file/" + histories[i].attachment[j].id + " ' target='black' style='text-decoration: underline;' >" + histories[i].attachment[j].name + "</a></p>";
        }
      }
    }
    return newHistory;
  }

  handleFileInput(event) {
    this.duplicateFiles = true
    let files = []
    let file_length = 0
    let isUploaded = false
    this.file_length = this.file_length + event.target.files.length
    for (let i = 0; i < event.target.files.length; i++) {
      this.file_size = this.file_size + event.target.files[i].size
      this.current_upload_size = this.current_upload_size + event.target.files[i].size
      this.UploadedFileName = event.target.files[i].name
      if (this.files) {
        for (let fileUploaded of this.files) {
          if (fileUploaded.name === event.target.files[i].name) {
            this.duplicateFiles = false
          }
        }
      }

      let regex = new RegExp('[*\\\\?\":{}|/<>]');
    }
    if (this.duplicateFiles) {
      if (this.file_size < 20 * 1024 * 1024) {
        if (this.file_length < 6) {
          for (let i = 0; i < event.target.files.length; i++) {
            let regex = new RegExp('[*\\\\?\":{}|/<>]');
            if (regex.test(event.target.files[i].name)) {
              this.file_length = this.file_length - event.target.files.length
              this.file_size = this.file_size - this.current_upload_size
              this.status = false;
              this.UploadFailedMessage = false
              this.sizeExceededMessage = false
              this.fileProgress = true
              this.regexFile = true
              this.UploadingFile = false
              this.regexFormat = "*?\\\":{}|/<>"
              break
            }

            if ((this.file_size < 20 * 1024 * 1024) && (this.file_length < 6) && (this.UploadedFileName.length <= 100)) {

              files.push(event.target.files[i]);
              this.regexFile = false
              isUploaded = true
              this.uploadedFileLength = event.target.files.length
              this.UploadingFile = true
              this.sizeExceededMessage = false
              this.UploadFailedMessage = false
              this.fileProgress = false
            }

            else if (this.file_size > 20 * 1024 * 1024) {
              isUploaded = false
              alert("All files cannot exceed 20MB")
            }
            else if (this.file_length >= 6) {
              isUploaded = false
              alert("Upload Files(max 5)")
            }
            else if (this.UploadedFileName.length > 100) {
              isUploaded = false
            }


            if (!isUploaded) {
              this.regexFile = false
              this.status = false;
              this.file_size = this.file_size - this.current_upload_size
              this.file_length = this.file_length - 1
            }
            else {
              let institutionId = this.homeService.institutionId
              const attachmentUrl = environment.api_vi + institutionId + environment.fileUpload
              const formdata = new FormData();
              for (let i = 0; i < files.length; i++) {
                formdata.append("file", files[i]);
                for (let fileName of files) {
                  this.UploadedFileName = fileName.name
                }
                this.http.post(attachmentUrl, formdata, {
                  reportProgress: true,
                  observe: 'events'
                }).subscribe(event => {
                  if (event.type === HttpEventType.UploadProgress) {
                    this.status = true;
                    this.progress = Math.round(event.loaded / event.total * 100)
                  } else if (event.type === HttpEventType.Response) {
                    this.fileProgress = true
                    this.UploadingFile = false
                    this.progress = 0;
                    this.status = false;
                  }
                })
                this.files = this.files.concat(files[i])
                files = []
              }

            }
          }
        }
        else {
          this.file_length = this.file_length - event.target.files.length
          this.file_size = this.file_size - this.current_upload_size
          this.UploadFailedMessage = true
          this.sizeExceededMessage = false
          this.fileProgress = true
          this.UploadingFile = false
          this.regexFile = false
        }
      }
      else {
        this.file_size = this.file_size - this.current_upload_size
        this.file_length = this.file_length - event.target.files.length
        this.sizeExceededMessage = true
        this.UploadFailedMessage = false
        this.fileProgress = true
        this.UploadingFile = false
        this.regexFile = false
      }
    }
    else {
      this.file_size = this.file_size - this.current_upload_size
      this.file_length = this.file_length - event.target.files.length
      this.sizeExceededMessage = false
      this.UploadFailedMessage = false
      this.fileProgress = true
      this.UploadingFile = false
      this.regexFile = false
    }
    this.current_upload_size = 0
  }

  executeAction(actionId) {
    this.submitted = true;
    this.form = {
      comment: this.comment,
      attachment: this.getAttachmentData()
    };
    this.homeService.postFields(this.caseId, actionId, this.form).subscribe(response => {
      location.reload()
    });
  }
  caseId(caseId: any, actionId: any, form: { comment: any; attachment: any[]; }) {
    throw new Error('Method not implemented.');
  }

  getAttachmentData() {
    let data = [];
    if (this.files) {
      for (var i = 0; i < this.files.length; i++) {
        this.field = {
          file_name: this.files[i].name,
          content_type: this.files[i].type,
          file_path: this.files[i].file_path
        }
        data.push(this.field)
      }
      return data
    }
  }
  remove(file) {
    let index = this.files.indexOf(file)
    this.files.splice(index, 1)
    this.file_size = this.file_size - file.size
    this.file_length = this.file_length - 1
    this.status = false
    this.regexFile = false
    this.sizeExceededMessage = false
    this.UploadFailedMessage = false
    this.UploadingFile = false
    this.duplicateFiles = true

  }

  checkIsCaseModalOpen(event) {
    this.checkCaseModalInHelpCenter = false;
  }
  openChat(){
    this.homeService.openChat.next(true);
  }
}
